import { RATING_SLIDES } from '@/modules/players/v3/constants/friends';
import type { GetFriendsSort } from '@/types/friends.types';

export interface FollowingDataHookParams {
  uuid: string;
  search?: string;
  sort?: GetFriendsSort;
  page?: number;
  pageSize?: number;
}

export enum FriendCardType {
  FRIEND = 'friend',
  REQUEST = 'request',
  PENDING = 'pending',
  SUGGESTION = 'suggestion',
  BLOCKED = 'blocked',
  FOLLOWING = 'following',
}

export enum RelationshipStatus {
  NONE = 'RELATIONSHIP_STATUS_NONE',
  FRIENDS = 'RELATIONSHIP_STATUS_FRIENDS',
  FOLLOWING = 'RELATIONSHIP_STATUS_FOLLOWING',
  REQUEST_SENT = 'RELATIONSHIP_STATUS_REQUEST_SENT',
  REQUEST_RECEIVED = 'RELATIONSHIP_STATUS_REQUEST_RECEIVED',
  BLOCKED = 'RELATIONSHIP_STATUS_BLOCKED',
  FOLLOWER = 'RELATIONSHIP_STATUS_FOLLOWER',
}

export enum FriendModalType {
  FRIEND = 'friend',
  PLAYER_INFO = 'player_info',
  ACCEPT_FRIEND_REQUEST = 'accept_friend_request',
  REJECT_FRIEND_REQUEST = 'reject_friend_request',
  REVOKE_FRIEND_REQUEST = 'revoke_friend_request',
  SEND_FRIEND_REQUEST = 'send_friend_request',
}

export enum FriendCardModalType {
  VIEW_INFO = 'view-info',
  BLOCK = 'block',
  UNFRIEND = 'unfriend',
  DECLINE = 'decline',
  REVOKE = 'revoke',
  UNBLOCK = 'unblock',
  MANAGE_NOTIFICATIONS = 'manage-notifications',
}

export enum RatingSlideType {
  APR = 'apr',
  DUPR = 'dupr',
}

export type RatingSlide = (typeof RATING_SLIDES)[number];
